import React from "react";
import { Box } from '@mui/joy';
import { Pie } from 'src/mtska-frontend-app-component';

const PieExpiration = ({ user, filters, createSliceFilterHandler, handleFilterChange, t }) => {
    return (
        <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Tutte le vetture")}<br></br>{t("in scadenza")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_general/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti VIP")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_vip/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "VIP (OVER 50)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti TOP")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_top/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "TOP (21-50)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti MEDIUM")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_medium/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "MEDIUM (6-20)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti SMALL")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_small/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "SMALL (2-5)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti SINGLE")}</>}
                    dataProviderName={"statisticsviews/fleetbyexpiration_single/expirationaggregate"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "SINGLE (1)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
        </Box>
    )
}

export default PieExpiration